import React from 'react';
import { ColumnType } from '../types/Column';
import { styled } from '../../Theme/theme';
import { DragDropContext, Draggable, DraggableProvided, Droppable } from '../../dnd-kit-compat';
import PortalAwareDraggableColumnItem from './PortalAwareDraggableColumnItem';
import { DragOverlayItem } from './DragOverlayItem';
type Props = {
    currGridColumns: ColumnType<any>[];
    setCurrGridColumns: React.Dispatch<React.SetStateAction<ColumnType<any>[]>>;
};

const reorder = (arr: Array<ColumnType<any>>, startIndex: number, endIndex: number) => {
    const result = Array.from(arr);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const CustomizeColumnsContent = ({ currGridColumns, setCurrGridColumns }: Props) => {
    const renderDragOverlay = (activeId: string) => {
        const index = parseInt(activeId);
        const item = currGridColumns[index];
        return item ? <DragOverlayItem item={item} /> : null;
    };

    return (
        <Container>
            <div>
                <DragDropContext
                    onDragEnd={(result) => {
                        if (!result.destination) {
                            return;
                        }
                        const items = reorder(currGridColumns, result.source.index, result.destination.index);
                        setCurrGridColumns(items);
                    }}
                    renderDragOverlay={renderDragOverlay}
                >
                    <Droppable droppableId="droppable-1" items={currGridColumns}>
                        {(provided, _snapshot) => (
                            <Columns ref={provided.innerRef} {...provided.droppableProps}>
                                {currGridColumns.map((item, index) => {
                                    return (
                                        <Draggable key={index} draggableId={'' + index} index={index} droppableId="droppable-1">
                                            {(provided: DraggableProvided, snapshot) => {
                                                return (
                                                    <PortalAwareDraggableColumnItem
                                                        provided={provided}
                                                        snapshot={snapshot}
                                                        index={index}
                                                        item={item}
                                                        currGridColumns={currGridColumns}
                                                        setCurrGridColumns={setCurrGridColumns}
                                                    />
                                                );
                                            }}
                                        </Draggable>
                                    );
                                })}
                                {provided.placeholder}
                            </Columns>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        </Container>
    );
};

export default CustomizeColumnsContent;

const Container = styled.div`
    border-bottom: 1px solid #eaeaea;
`;

const Columns = styled.div`
    max-height: 400px;
    overflow-y: auto;
    padding: 10px 30px;
`;
